"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var url_1 = __importDefault(require("url"));

var querystring_1 = __importDefault(require("querystring"));

var getQueryParam = function getQueryParam(name, url) {
  var query;

  if (!url) {
    query = window.location.search.substr(1);
  } else {
    query = url_1.default.parse(url).query;
  }

  var params = querystring_1.default.parse(query);

  if (params[name]) {
    return params[name];
  }

  return null;
};

exports.default = getQueryParam;